export default (axios) => ({
  sendMail(payload) {
    return axios.post('v1/contact_us', payload)
  },
})
